// extracted by mini-css-extract-plugin
export default {"trackingMode":"manage-projects-page-trackingMode-GsyU3r"};